import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'

const UiSetttings = () => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { allUi, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: 'ui_settings',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive'
            ) {
                dataValue.active = dataValue.action === 'active' ? 1 : 0
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })

    const validationArray = Yup.object({
        ui_key: Yup.string().required('Required!'),
        ui_type: Yup.string().required('Required!'),
        image: Yup.array().when('ui_type', {
            is: 'image',
            then: Yup.array().required('Required!'),
        }),
        ui_value: Yup.string().when('ui_type', {
            is: 'text',
            then: Yup.string().required('Required!'),
        }),
    })

    const formikView = useFormik({
        initialValues: {
            page: 1,
            filters: true,
            primaryTable: 'ui_settings',
            searchterm: '',
            limit: 20,
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'ui')
        },
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            ui_key: '',
            ui_value: '',
            ui_type: '',
            image: '',
            table: 'ui_settings',
            active: 1,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.ui_type == 'image') {
                values.ui_value = values.image[0]
            }
            searchTableAction(values)
        },
    })

    const changePagination = () => {
        searchTableFetch(formikView.values, 'ui')
    }

    useEffect(() => {
        if (allUi) {
            setTableBody(allUi.length ? allUi : [])
            formikView.values.limit = allUi.length
        }
        setIsLoading(false)
    }, [allUi])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'ui') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])
    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                toggleFullScreenPopup(false)
                setTableBody([])
                getGlobalVariable()
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    useEffect(() => {
        if (manage.status === 'edit') {
            formik.setFieldValue('id', manage.id)
            const template = allUi.filter((cat) => cat.id === manage.id)
            console.log('template', template)
            let data = {}
            if (template[0].ui_type === 'image') {
                data = {
                    ...formik.values,
                    ...template[0],
                    image: [template[0].ui_value],
                }
            } else {
                data = {
                    ...formik.values,
                    ...template[0],
                }
            }
            formik.setValues(data)
        } else {
            resetFrom()
        }
    }, [manage])
    useEffect(() => {
        if (manage.status === 'edit') {
            const template = allUi.filter((cat) => cat.id === manage.id)
            if (
                template[0].ui_type === 'image' &&
                formik.values.ui_type === 'image'
            ) {
                formik.values.image = [template[0].ui_value]
                formik.values.ui_value = ''
            } else if (
                template[0].ui_type === 'text' ||
                (template[0].ui_type === 'color' &&
                    formik.values.ui_type === 'image')
            ) {
                formik.values.ui_value = template[0].ui_value
                formik.values.image = []
            }
        }
    }, [formik.values.ui_type])
    const resetFrom = () => {
        formik.setValues({
            id: 0,
            ui_key: '',
            ui_value: '',
            ui_type: '',
            image: [],
            table: 'ui_settings',
            active: 1,
        })
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'ui_key',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Name *',
            filterable: true,
            filterField: 'ui_key',
        },
        {
            field: 'ui_value',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Type *',
            filterable: true,
            filterField: 'ui_value',
        },
        {
            field: 'active',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'active',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Active',
                },
                false: {
                    type: 'text',
                    value: 'Deactive',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Edit Ui Settings',
        },
    ]
    let details = [
        {
            label: 'Name *',
            placeholder: 'Enter the Name',
            type: 'textarea',
            class: 'col-12',
            name: 'ui_key',
            formik: formik,
        },
        {
            label: 'Type *',
            placeholder: 'Select Type',
            type: 'select',
            class: 'col-sm-6 col-12',
            options: [
                { value: 'text', show: 'Text' },
                { value: 'image', show: 'Image' },
                { value: 'color', show: 'Color' },
            ],
            defaultOptionValue: 'Select a Location',
            name: 'ui_type',
            formik: formik,
        },
    ]

    if (formik.values.ui_type === 'image') {
        details.push({
            type: 'uploadDropZone',
            name: 'image',
            icon: 'image',
            class: 'col-6',
            titleText: 'Upload your logo here',
            folder: 'site',
            multiple: false,
            accept: 'image/*, application/*',
            formik: formik,
        })
    } else if (formik.values.ui_type === 'color') {
        details.push({
            type: 'misc',
            content: <p>Select a color</p>,
            class: 'col-12 mt-1 profileHelper text-left',
            formik: formik,
        })
        details.push({
            type: 'colorpicker',
            name: 'ui_value',
            class: 'col-6 mb-4',
        })
    } else {
        details.push({
            label: 'Enter Text',
            type: 'text',
            placeholder: 'Enter Text',
            class: 'col-md-6 col-sm-12',
            name: 'ui_value',
            formik: formik,
        })
    }
    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (action === 'active' || action === 'deactive') {
            setChangeStatus(true)
        }
    }

    useEffect(() => {
        if (previous_data) {
            if (previous_data.records.length) {
                setAlert('Previous records exists!', 'error')
                formikSelection.values.action = ''
                formikSelection.values.id = 0
                clearPreviousData()
            } else if (formikSelection.values.action) {
                setChangeStatus(true)
            }
        }
    }, [previous_data])

    const tableActions = []
    tableActions.push(
        {
            label: 'Move to Active',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        },
        {
            label: 'Move to Deactive',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactive',
        }
    )

    const searchInfo = [
        {
            label: 'UI search ',
            placeholder: 'Enter Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formikView,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
                    <Button
                        id="ui_setting_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        UI Setting
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={{
                        records: allUi,
                        setDisp: `0-${allUi.length}`,
                        totalRecords: allUi.length,
                    }}
                    changeTableFunction={changePagination}
                />
            </div>
            <FullScreenPopup
                modaltitle={
                    manage.status === 'new'
                        ? 'Add New Location'
                        : 'Edit Location'
                }
                open={manage.popup}
                handleClose={() => toggleFullScreenPopup(false, 'new', 0)}
            >
                <div className="dashboard addNewListing mt-4">
                    <div className="fspBody">
                        <div className="row">
                            {Object.values(mapData(details))}
                        </div>
                        <div className="actionButton d-flex justify-content-center align-items-center">
                            <SecondaryButton
                                id="ui_cancel"
                                label="Cancel"
                                onClick={() => toggleFullScreenPopup(false)}
                            />
                            <PrimaryButton
                                id="ui_submit"
                                onClick={() => formik.handleSubmit()}
                                type="submit"
                                label="Submit"
                            />
                        </div>
                    </div>
                </div>
            </FullScreenPopup>

            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>{'Are you sure you want to change the status'}</h5>
                <div className="actionWrapper">
                    <Button
                        id="ui_setting_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="ui_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default UiSetttings
